<template>
  <v-app>
    <!-- @detected-condition fires when the connectivity status of the device changes -->
    <offline @detected-condition="handleConnectivityChange"/>
    <notifications position="top center" group="app" :max="1"/>
    <v-dialog v-model="idleWarningVisible" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">¿Sigue ahí?</v-card-title>
        <v-card-text>
          Su sesión se cerrará por inactividad en {{ idleSecondsRemaining }} segundos.
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary" text @click="continueSession">Continuar sesión</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <router-view/>
  </v-app>
</template>

<script>
import offline from "v-offline";
import IdleService, { idleBus } from "./services/IdleService";

export default {
  components: {
    offline
  },
  data() {
    return {
      firstTime: true
    };
  },
  computed: {
    idleWarningVisible: {
      get() {
        return idleBus.warningVisible;
      },
      set(value) {
        idleBus.warningVisible = value;
      }
    },
    idleSecondsRemaining() {
      return idleBus.secondsRemaining;
    }
  },
  methods: {
    continueSession() {
      IdleService.continueSession();
    },
    handleConnectivityChange(status) {
      let message = "Sin conexión 🙁";
      let type = "error";
      if (status) {
        message = "Conectado! 😃";
        type = "success";
      }

      if (!this.firstTime) {
        this.$notify({
          group: "app",
          type: type,
          text: message
        });
      }

      this.firstTime = false;
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/index.scss";

/* Remove in 1.2 */
.v-datatable thead th.column.sortable i {
  vertical-align: unset;
}

.v-menu__content.theme--light div.v-picker__body.theme--light button {
  color: black !important;
}

.container {
  padding: 0 24px;
}
</style>
